import { validateSecurity } from 'common/secure/validate'

export function secureRoute(demands, path = '/') {
    return () => {
        return validateSecurity(demands) ? null : path
    }
}

export default secureRoute
